var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavePlanet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6923 77.924L23.6923 73.4112L11.7829 59.5174C10.7315 58.2903 10.1536 56.7276 10.1538 55.1117L10.1538 34.4881C10.1538 33.4409 10.5698 32.4365 11.3104 31.696C12.0509 30.9554 13.0553 30.5394 14.1025 30.5394C15.1498 30.5394 16.1542 30.9554 16.8947 31.696C17.6352 32.4365 18.0512 33.4409 18.0512 34.4881L18.0512 47.6092",
    stroke: "#34749C",
    strokeWidth: 2.70769,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2307 77.924L37.2307 62.6764C37.2306 60.8813 36.5176 59.1599 35.2485 57.8905L24.2563 46.8984C23.886 46.5279 23.4463 46.2341 22.9623 46.0336C22.4784 45.8331 21.9597 45.7299 21.4358 45.7299C20.912 45.7299 20.3933 45.8331 19.9093 46.0336C19.4254 46.2341 18.9857 46.5279 18.6153 46.8984C18.2449 47.2688 17.951 47.7085 17.7505 48.1924C17.55 48.6764 17.4468 49.1951 17.4468 49.7189C17.4468 50.2428 17.55 50.7615 17.7505 51.2454C17.951 51.7294 18.2449 52.1691 18.6153 52.5394L27.0769 61.001",
    stroke: "#34749C",
    strokeWidth: 2.70769,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3076 77.924V73.4112L76.217 59.5174C77.2684 58.2903 77.8463 56.7276 77.8461 55.1117V34.4881C77.8461 33.4409 77.4301 32.4365 76.6895 31.696C75.949 30.9554 74.9446 30.5394 73.8974 30.5394C72.8501 30.5394 71.8457 30.9554 71.1052 31.696C70.3647 32.4365 69.9486 33.4409 69.9486 34.4881V47.6092",
    stroke: "#34749C",
    strokeWidth: 2.70769,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7693 77.924V62.6764C50.7694 60.8813 51.4824 59.1599 52.7515 57.8905L63.7436 46.8984C64.114 46.5279 64.5537 46.2341 65.0377 46.0336C65.5216 45.8331 66.0403 45.7299 66.5642 45.7299C67.088 45.7299 67.6067 45.8331 68.0907 46.0336C68.5746 46.2341 69.0143 46.5279 69.3847 46.8984C69.7551 47.2688 70.049 47.7085 70.2495 48.1924C70.45 48.6764 70.5532 49.1951 70.5532 49.7189C70.5532 50.2428 70.45 50.7615 70.2495 51.2454C70.049 51.7294 69.7551 52.1691 69.3847 52.5394L60.9231 61.001",
    stroke: "#34749C",
    strokeWidth: 2.70769,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0769 27.1548L60.9231 27.1548",
    stroke: "#34749C",
    strokeWidth: 2.70769,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44 44.0779C53.3463 44.0779 60.9231 36.5012 60.9231 27.1548C60.9231 17.8084 53.3463 10.2317 44 10.2317C34.6536 10.2317 27.0769 17.8084 27.0769 27.1548C27.0769 36.5012 34.6536 44.0779 44 44.0779Z",
    stroke: "#34749C",
    strokeWidth: 2.70769,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0001 44.0779C48.0059 44.0779 51.2533 36.5012 51.2533 27.1548C51.2533 17.8084 48.0059 10.2317 44.0001 10.2317C39.9942 10.2317 36.7468 17.8084 36.7468 27.1548C36.7468 36.5012 39.9942 44.0779 44.0001 44.0779Z",
    stroke: "#34749C",
    strokeWidth: 2.70769,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavePlanet1);
export default __webpack_public_path__ + "static/media/save-planet-1.4a8155d3076727534050be2713e19d07.svg";
export { ForwardRef as ReactComponent };